import { IGlobalReducerState } from '../Base/interface/IGlobalReducerState';

const getTenants = (state: IGlobalReducerState) => state.tenant.Tenants;
const getCurrentTenant = (state: IGlobalReducerState) => state.tenant.currentListTenant;
const getUsersWithConstruction = (state: IGlobalReducerState) => state.tenant.UsersWithConstruction;

export { getTenants, getCurrentTenant, getUsersWithConstruction };
